import { featureFlags } from "@utils/featureFlags";

import type { PolicyDetailsContentProps } from "../../types";
import { EndorsementAdditionalInterests } from "./EndorsementAdditionalInterests";
import { LegacyAdditionalInterests } from "./LegacyAdditionalInterests";

export const AdditionalInterests = (props: PolicyDetailsContentProps) =>
  featureFlags.endorsementsTabEnabled.isEnabled() ? (
    <EndorsementAdditionalInterests {...props} />
  ) : (
    <LegacyAdditionalInterests {...props} />
  );
